module.exports = __webpack_public_path__ + "static/media/logo.02965a86.png";